export const analyticsApplicationInfo = {
  namespace: 'EM',
  platform: 'Equipment_Management',
  country: 'International',
};
